import { FC } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { hideSessionExpiredModal } from "../../app.slice";
import { sendTabEvent } from "../../hooks/useBrowserTabEvent";
import { BROADCAST_EVENT } from "../../hooks/useBrowserTabEvent";
import { logoutUser } from "../../modules/auth/features/auth.slice";
import useAuth from "../../modules/auth/hooks/useAuth";
import { setEncodedUrl } from "../../utils/session";

const SessionExpiredModal: FC = () => {
  const dispatch = useDispatch();
  const { currentUser } = useAuth();
  const showModal = useSelector((state: RootState) => state.app.showSessionExpiredModal);

  const handleLoginAgain = () => {
    const currentPath = window.location.pathname + window.location.search;
    setEncodedUrl(currentPath, currentUser?.user_id);
    dispatch(logoutUser());
    dispatch(hideSessionExpiredModal());
    sendTabEvent(BROADCAST_EVENT.LOGOUT_EVENT, { redirectUrl: currentPath });
  };

  return (
    <Modal show={showModal} backdrop="static" keyboard={false} centered className="session-expired-modal">
      <Modal.Header>
        <Modal.Title>Session Expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Your session has expired. You need to login again to continue.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleLoginAgain}>
          Login Again
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionExpiredModal;
